import React from "react";
import { useIntl } from "react-intl";
import "./styles.scss";

const ExportButton = ({ textId, onClick, isLoading, ...props }) => {
	const { formatMessage } = useIntl();

  return (
    <>
			<button
				className={`button ${isLoading ? " is-loading" : ""}`}
				onClick={onClick}
				{...props}
			>
				{formatMessage({ id: textId })}
			</button>
    </>
  );
};

export default ExportButton;

